// extracted by mini-css-extract-plugin
module.exports = {"notFoundContainer":"NotFound_notFoundContainer__2F0r1"};